import { Component, OnInit, input, signal } from '@angular/core';

import { ButtonModule } from 'primeng/button';
import { CardComponent } from '../../../../../shared/components/card/card.component';
import { DatePipe } from '@angular/common';
import { MessageService } from 'primeng/api';
import { Pagination } from '../../../../../shared/models/pagination.model';
import { VaccineHistory } from '../../../../../shared/models/vaccine-history.model';
import { VaccineHistoryModalComponent } from '../../../../../components/modals/vaccine-history-modal/vaccine-history-modal.component';
import { VaccineHistoryService } from '../../../../../services/vaccine-history/vaccine-history.service';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-vaccine-history-section',
  imports: [
    VaccineHistoryModalComponent,
    ButtonModule,
    CardComponent,
    DatePipe
  ],
  templateUrl: './vaccine-history-section.component.html',
  styleUrl: './vaccine-history-section.component.scss'
})
export class VaccineHistorySectionComponent implements OnInit {
  readonly petId = input.required<string>();

  readonly isModalOpen = signal<boolean>(false);
  readonly isModalDeleteMode = signal<boolean>(false);

  readonly isCardLoading = signal<boolean>(true);
  readonly selectedVaccineHistory = signal<VaccineHistory | null>(null);
  readonly vaccineHistories = signal<VaccineHistory[]>([]);

  readonly nextPage = signal<number>(0);
  readonly totalVaccineHistories = signal<number>(0);


  constructor(private readonly vaccineHistoryService: VaccineHistoryService,
    private readonly messageService: MessageService
  ) { }

  ngOnInit(): void {
    this.fetchVaccineHistory(0, true);
  }

  onModalOpen(isModalDelete: boolean, idx: number | null = null, event: MouseEvent | null = null): void {
    if (event) {
      event.stopPropagation();
    }

    this.selectedVaccineHistory.set(idx !== null ? this.vaccineHistories()[idx] : null);
    this.isModalDeleteMode.set(isModalDelete);
    this.isModalOpen.set(true);
  }

  fetchVaccineHistory(page: number, resetList: boolean = false): void {
    this.isCardLoading.set(true);
    this.vaccineHistoryService.paginateVaccineHistoryByPetId(this.petId(), page)
      .pipe(finalize(() => this.isCardLoading.set(false)))
      .subscribe({
        next: (vaccineHistoryPage: Pagination<VaccineHistory>) => {
          if (resetList) {
            this.vaccineHistories.set(vaccineHistoryPage.rows);
            this.nextPage.set(1);
          } else {
            this.vaccineHistories.update(prev => [...prev, ...vaccineHistoryPage.rows]);
            this.nextPage.update(prev => prev + 1);
          }

          this.totalVaccineHistories.set(vaccineHistoryPage.count);
        },
        error: () => {
          this.messageService.add({ severity: 'error', summary: 'Erro', detail: 'Falha ao recuperar histórico de vacinação!' });
        }
      });
  }
}
